import React from "react";
import { BuildingObject } from "@shared/Map/types";
import { Tower } from "@shared/Map/objects/structures/Tower";
import { Inhibitor } from "@shared/Map/objects/structures/Inhibitor";
import frameBuildings from "../../../Sidebar/panels/StructuresPanel/buildings.json";

interface BuildingProps {
	building: BuildingObject;
}

const Building: React.FC<BuildingProps> = (props) => {
	// @ts-ignore
	const baseBuilding = frameBuildings[props.building.id] as BuildingObject;
	const mergedBuilding = { ...baseBuilding, ...props.building };

	if (mergedBuilding.buildingType == "INHIBITOR") {
		return <Inhibitor inhib={mergedBuilding} />;
	} else if (mergedBuilding.buildingType == "NEXUS") {
		return <></>;
	} else {
		return <Tower tower={mergedBuilding} />;
	}
};

export { Building };
